export default __webpack_public_path__ + "static/media/Valorant_logo.140c7038.svg";